import { Chip, Flex } from '@percent/lemonade'
import { DisbursementsFiltersProps } from './DisbursementsFilters.types'
import { useDisbursementFilterChips } from './useDisbursementFilterChips'

/**
 * Summarises what is filtering the list, one chip per active filter, each removable on its own.
 * Wraps because every filter can be active at once and the row would otherwise push the table wide.
 */
export function DisbursementsFilterChips({ queryParams, setQueryParams }: DisbursementsFiltersProps) {
  const chips = useDisbursementFilterChips({ queryParams, setQueryParams })

  if (!chips.length) {
    return null
  }

  return (
    <Flex wrap="wrap" align="center" gap={8} data-testid="disbursements-filter-chips">
      {chips.map(({ id, label, value, onRemove }) => (
        <Chip key={id} label={label} value={value} onClick={onRemove} testId={`disbursements-chip-${id}`} />
      ))}
    </Flex>
  )
}
